import { useFavoriteMutations } from '@/features/favorites/useFavoriteMutations';

interface FavoriteToggleButtonProps {
  generationImageId: string;
  favoriteId: string | null;
  isFavorite: boolean;
}

export function FavoriteToggleButton({
  generationImageId,
  favoriteId,
  isFavorite,
}: FavoriteToggleButtonProps) {
  const { add, remove } = useFavoriteMutations();
  const isPending = add.isPending || remove.isPending;

  function handleClick() {
    if (isFavorite && favoriteId) {
      remove.mutate(favoriteId);
    } else {
      add.mutate(generationImageId);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isPending}
      className="btn btn-secondary px-4 py-2 text-sm"
    >
      {isFavorite ? 'Убрать из избранного' : 'В избранное'}
    </button>
  );
}
